import React, { useContext } from 'react';
import { Divider } from 'antd';

import SurveyContext from '@totem/components/surveyV2/instanceDetail/SurveyInstanceContext';
import SurveyInstanceDetail from '@totem/components/surveyV2/instanceDetail/SurveyInstanceDetail';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import colors from '@totem/styles/colors';
import { isVendorUser } from '@totem/utilities/authUtilities';
import { isNull } from '@totem/utilities/common';

import '../survey.css';

const styles = {
  divider: {
    background: colors.neutral.gray,
  },
  dateDivider: {
    height: '5rem',
    margin: '0 2rem',
  },
  alert: {
    margin: '1rem 0 2rem 0',
  },
  iframeContainer: {
    position: 'relative',
    paddingBottom: '56.25%',
    paddingTop: '2.5rem',
    height: 0,
    marginBottom: '3rem',
  },
  iframe: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
  },
};

const SurveyInstanceDetailWrapper = () => {
  const { userProfile } = useContext(UserProfileContext);
  const { data } = useContext(SurveyContext);

  const parseDate = (date: number): string => {
    if (date) {
      return new Date(date).toLocaleDateString();
    }
    return '';
  };

  const getHeaderContentRight = () => {
    return data.survey.startDate && data.survey.dueDate ? (
      <div styleName="dates-container">
        <div>
          <div styleName="date-title">Start Date</div>
          <div styleName="date">
            {data.survey.startDate ? parseDate(data.survey.startDate) : ''}
          </div>
        </div>
        <Divider orientation="vertical" style={styles.dateDivider} />
        <div>
          <div styleName="date-title">Due Date</div>
          <div styleName="date">
            {data.survey.dueDate ? parseDate(data.survey.dueDate) : ''}
          </div>
        </div>
      </div>
    ) : null;
  };

  return (
    <>
      {typeof data !== 'undefined' &&
        data !== null &&
        typeof data.survey !== 'undefined' &&
        data.survey !== null && (
          <ContentLayout
            pageTitle={data.survey.name}
            pageSubtitle={[
              { label: data.region.name },
              {
                label: data.building.name,
                link:
                  isNull(userProfile) || isVendorUser(userProfile)
                    ? ''
                    : `/dashboard/buildings/${data.building.id}`,
              },
            ]}
            breadcrumbs={(breadcrumbs) => [
              ...breadcrumbs,
              { label: data.survey.name },
            ]}
            contentRight={getHeaderContentRight()}
          >
            <SurveyInstanceDetail />
          </ContentLayout>
        )}
    </>
  );
};

export default SurveyInstanceDetailWrapper;
